import React from "react";
import { Carousel, Select } from "antd";
import { withTranslation } from "react-i18next"
import WOW from 'wowjs'
import '../../../node_modules/wowjs/css/libs/animate.css'
import i18n from "../../utils/i18n";
import "./index.css"; 
import config from '../../utils/config';
import u1 from '../../assets/icons/u1.svg'
import img1 from '../../assets/icons/u56-2.png'
import img2 from'../../assets/icons/u37-2.png'
import img3 from'../../assets/icons/u38-2.png'
import img4 from'../../assets/icons/u39.png'
import u15 from '../../assets/icons/u15.svg'
import dd from '../../assets/icons/dd.png'
import u2 from '../../assets/icons/u2.gif'
import u27 from '../../assets/icons/u27.svg'
import u19 from '../../assets/icons/u19.svg'
import yl from '../../assets/icons/yl.png'
import u23 from '../../assets/icons/u23.svg'
import dt from '../../assets/icons/dt.png'

const { Option } = Select;
  class NavHeader extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            languageType: localStorage.getItem('languageType')
        }
    }

    componentDidMount(){
        new WOW.WOW().init();
        const languageType = localStorage.getItem('languageType');
        i18n.changeLanguage(languageType);
        console.log('languageType===',languageType);
    }

    menuListLeft = [
        {
            title: this.props.t('gyitms', { defaultValue: '关于ITMS' }),
            code: "gyitms",
        },
        {
            title: this.props.t('yqlj'),
            code: "yqlj",
        },
    ];

    menuListRight = [
        {
            title: this.props.t('lxwm'),
            code: "lxwm",
        },
        {
            title: this.props.t('gzyxz'),
            code: "gzyxz",
        },
        {
            title: this.props.t('tsjy'),
            code: "tsjy",
        },
    ]

    btnClick = () =>{
        this.props.history.push('/login');
    }

    toDetail = () =>{
        const url = `${config.DOMAIN_NAME}/momey`
        window.open(url, '_blank');
    }

    languageChange = (e) =>{
        console.log(e);
        // const value = e.target.value;
        i18n.changeLanguage(e);
        localStorage.setItem('languageType', e);
        window.location.reload()
    }
    render() {
        // const { data } = this.props;
        console.log('data:',this.props);
        return (
            <div className="wrapper-box">
                <div className="box-top">
                    <div className="top-left">
                        <div>
                            {/*  eslint-disable-next-line jsx-a11y/alt-text */}
                            <object data={u1} type="image/svg+xml" />
                        </div>
                        <p style={{marginLeft:10}}>
                            iTMS
                        </p>
                        {this.menuListLeft.map((item) =>{
                            return <span key={item.title} >{item.title}</span>
                        })}
                    </div>
                    <div className="top-right">
                        {this.menuListRight.map((item) =>{
                            return <span className="top-right-title" key={item.title} >{item.title}</span>
                        })}
                        <span className="top-right-select">
                            <Select defaultValue={this.state.languageType ? this.state.languageType: 'zh'} onChange={this.languageChange}>
                                <Option value="zh">中文(zh-CN)</Option>
                                <Option value="en">English</Option>
                                <Option value="ina">Indonesia</Option>
                                <Option value="fr_FR">Français</Option>
                                <Option value="es_ES">Español</Option>
                                <Option value="th_TH">ภาษาไท</Option>
                                <Option value="ru_RU">Русский</Option>
                                <Option value="ms_MS">Melayu</Option>
                                <Option value="pt_PT">Português</Option>
                                <Option value="vi_VI">Tiếng Việt</Option>
                                <Option value="ar_AR">اللغة العربية</Option>
                            </Select>
                            {/* <select className="select_language">
                            <option value="zh_CN">简体中文(Simple Chinese)</option>
                            <option value="en_US">English</option>
                            </select> */}
                        </span>
                        <span onClick={this.btnClick.bind(this)} className="top-right-btn" >
                           { this.props.t('login') }
                        </span>
                    </div>
                </div>
                {this.state.languageType !=='en'  && (
                    <div className="box" id="banner" onClick={this.toDetail}>
                        <Carousel autoplay>
                            <div>
                                <img src={img1} alt="" />
                            </div>
                            <div>
                            <img src={img2} alt="" />
                            </div>
                            <div>
                            <img src={img3} alt="" />
                            </div>
                            <div>
                            <img src={img4} alt="" />
                            </div>
                        </Carousel>
                    </div>
                )}
                
                <div className="content1 contentBack" style={{padding:0}}>
                    <div className="box-content">
                    <div className="wow slideInLeft" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="con-img">
                        <img src={dd} alt='' />
                        </div>
                    </div>
                    <div className="wow slideInRight wow_flex" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="ant-col">
                        <div name="icon" className="pricing0-icon">
                            <img src={u15} alt="oms.svg" />
                        </div>
                        <h1 name="title" className="pricing0-title">
                            <span>
                            <p>{this.props.t('blockTit1')}</p>
                            </span>
                        </h1>
                        <div name="content" className="pricing0-content">
                            <span>
                            <p>{ this.props.t('blockInfo1') }</p>
                            </span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="content">
                    <div className="box-content">
                    <div className="wow slideInLeft wow_flex" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="ant-col">
                        <div name="icon" className="pricing0-icon">
                            <img src={u19} alt="oms.svg" />
                        </div>
                        <h1 name="title" className="pricing0-title title-span" >
                            <span>
                            <p>{this.props.t('blockTit2')}</p>
                            </span>
                        </h1>
                        <div name="content" className="pricing0-content">
                            <span>
                            <p>{ this.props.t('blockInfo2') }</p>
                            </span>
                        </div>
                        </div>
                    </div>
                    <div className="wow slideInRight" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="con-img con-img-pos">
                        <img src={yl} alt='' />
                        </div>
                    </div>
                    </div>
                </div>
                
                <div className="content contentBack">
                    <div className="box-content">
                    <div className="wow slideInLeft" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="con-img con-img2">
                        <img src={u2} alt='' />
                        </div>
                    </div>
                    <div className="wow slideInRight wow_flex" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="ant-col">
                        <div name="icon" className="pricing0-icon">
                            <img src={u27} alt="oms.svg" />
                        </div>
                        <h1 name="title" className="pricing0-title">
                            <span>
                            <p>{this.props.t('blockTit3')}</p>
                            </span>
                        </h1>
                        <div name="content" className="pricing0-content">
                            <span>
                            <p>{ this.props.t('blockInfo3') }</p>
                            </span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="content">
                    <div className="box-content">
                    <div className="wow slideInLeft wow_flex" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="ant-col">
                        <div name="icon" className="pricing0-icon title-span" >
                            <img src={u23} alt="oms.svg" />
                        </div>
                        <h1 name="title" className="pricing0-title">
                            <span>
                            <p i18n="i18n.blockTit4">{this.props.t('blockTit4', { defaultValue:'运输跟踪'})}</p>
                            </span>
                        </h1>
                        <div name="content" className="pricing0-content">
                            <span>
                            <p>{ this.props.t('blockInfo4', { defaultValue:'由交付需求驱动运输调度计划、发货管理、在途跟踪监控、送达签收，全程透明化管理物流信息过程，实现统一平台上的多方协同管理。'}) }</p>
                            </span>
                        </div>
                        </div>
                    </div>
                    <div className="wow slideInRight" data-wow-duration="1s" data-wow-delay="0.1s">
                        <div className="con-img con-img3">
                        <img src={dt} alt='' />
                        </div>
                    </div>

                    </div>
                </div>
                <div style={{height: 30}} ></div>
                <div className="box-bottom">
                    {this.props.t('copyRight', { defaultValue:'@三一集团有限公司 版权所有 | 湘ICP备10005672号-14'})}
                </div>
            </div>
        )
    }
}

// export default NavHeader
export default NavHeader = withTranslation()(NavHeader);

  

  
